module.exports = __webpack_public_path__ + "static/media/event.d1ef18cb.png";